import { SxProps } from '@mui/system';
import { Button, ButtonProps, styled, Theme } from '@mui/material';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle, faCheckCircle } from '@fortawesome/free-regular-svg-icons';

import { CerebroIcon } from './CerebroIcon';
import { fontFamily, weights } from '../context/CerebroThemeProvider';

export const CerebroPill: React.FC<CerebroPillProps> = ({
	small = false,
	disabled = false,
	error = false,
	selected = false,
	onClick,
	sx,
	children,
}) => {
	return (
		<StyledPill small={small} disabled={disabled} error={error} selected={selected} onClick={onClick} sx={sx}>
			<CerebroIcon sx={{ marginRight: 1 }}>
				<FontAwesomeIcon icon={selected ? faCheckCircle : faCircle} />
			</CerebroIcon>
			{children}
		</StyledPill>
	);
};

interface CerebroPillProps {
	disabled?: boolean;
	small?: boolean;
	error?: boolean;
	sx?: SxProps<Theme>;
	selected?: boolean;
	onClick: React.MouseEventHandler<HTMLButtonElement>;
}

const Pill: React.FC<ButtonProps & { small?: boolean; selected: boolean; error: boolean }> = props => (
	<Button {...props} />
);

const StyledPill = styled(Pill, {
	shouldForwardProp: prop => prop !== 'selected' && prop !== 'error' && prop !== 'small',
})(({ small, disabled, error, selected, theme }) => ({
	backgroundColor: selected ? theme.palette.primary.main : theme.palette.gray.background,
	borderStyle: 'solid',
	borderWidth: 1,
	borderColor: error
		? theme.palette.error.main
		: selected
		? theme.palette.primary.main
		: disabled
		? theme.palette.gray.light
		: theme.palette.gray.dark,
	borderRadius: 100,
	color: disabled ? theme.palette.gray.medium : theme.palette.gray.dark,

	display: 'inline-block',

	fontFamily,
	fontSize: 12,
	fontWeight: weights.semibold,

	lineHeight: '14px',

	padding: small ? theme.spacing(0.75, 1.5) : theme.spacing(1.5, 2.5),

	width: 'auto',

	'&:hover': {
		backgroundColor: selected ? theme.palette.primary.light : theme.palette.action.hover,
		borderColor: error ? theme.palette.error.main : selected ? theme.palette.gray.dark : theme.palette.primary.main,
		boxShadow: error
			? theme.solidShadow(theme.palette.error.main)
			: selected
			? 'none'
			: theme.solidShadow(theme.palette.primary.main),
	},
}));
